import { render, staticRenderFns } from "./Confer.vue?vue&type=template&id=9b3c5abe&scoped=true"
import script from "./Confer.vue?vue&type=script&lang=js"
export * from "./Confer.vue?vue&type=script&lang=js"
import style0 from "./Confer.vue?vue&type=style&index=0&id=9b3c5abe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3c5abe",
  null
  
)

export default component.exports